import { Button, Col, Form, Input, Modal, Row } from 'antd';
import Title from 'antd/es/typography/Title';
import { useAppDispatch, useAppSelector } from 'app/config/store';
import React, { useEffect } from 'react';
import { Container } from 'reactstrap';
import { createEntity, getEntity, updateEntity } from '../person.reducer';

type IUpdatePerson = {
  isOpen: boolean;
  onClose: (isReload?: boolean) => void;
  id?: string;
};

export const PersonUpdate = ({ isOpen, onClose, id }: IUpdatePerson) => {
  const dispatch = useAppDispatch();
  const [form] = Form.useForm();
  const isNew = id === undefined || id === null;

  const personEntity = useAppSelector(state => state.person.entity);
  const updating = useAppSelector(state => state.person.updating);
  const updateSuccess = useAppSelector(state => state.person.updateSuccess);

  const handleClose = () => {
    form.resetFields();
    onClose(updateSuccess);
  };

  useEffect(() => {
    innitData();
  }, [isOpen]);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  useEffect(() => {
    if (personEntity && !isNew) {
      form.setFieldsValue(personEntity);
    }
  }, [personEntity]);

  const innitData = () => {
    // get detail
    if (isNew) {
      form.resetFields();
    } else {
      dispatch(getEntity(id));
    }
  };

  const handleSubmit = values => {
    const oldData = !isNew && personEntity;
    const entity = {
      ...oldData,
      ...values,
    };
    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  return (
    <Modal
      open={isOpen}
      maskClosable={false}
      onCancel={() => {
        onClose();
      }}
      footer={null}
      width={900}
    >
      <Container className="form">
        <Form size="large" form={form} onFinish={handleSubmit} layout="vertical">
          <Title level={3}>{`${id ? 'Cập nhật thông tin' : 'Thêm mới'} nhân sự`}</Title>
          <Row>
            <Col md={24}>
              <Form.Item label="Họ và tên" rules={[{ required: true, message: 'Hãy nhập họ và tên' }]} name={'name'}>
                <Input className="w-100" size="large" placeholder="Nhập họ và tên" />
              </Form.Item>
            </Col>
          </Row>
          <Row>
            <Col md={24}>
              <Form.Item label="Email login" rules={[{ required: true, message: 'Hãy nhập địa chỉ email' }]} name={'loginEmail'}>
                <Input type="email" className="w-100" size="large" placeholder="Nhập địa chỉ email" />
              </Form.Item>
            </Col>
          </Row>
          <Row>
            <Col md={24}>
              <Form.Item label="Email nhận thông báo" rules={[{ required: true, message: 'Hãy nhập địa chỉ email nhận thông báo' }]} name={'email'}>
                <Input type="email" className="w-100" size="large" placeholder="Nhập địa chỉ email nhận thông báo" />
              </Form.Item>
            </Col>
          </Row>
          <Form.Item>
            <Row className="action mt-3" justify="end">
              <Col>
                <Button className="primary" htmlType="submit" disabled={updating}>
                  Lưu
                </Button>
              </Col>
              <Col>
                <Button
                  className="secondary"
                  onClick={() => {
                    handleClose();
                  }}
                >
                  Hủy
                </Button>
              </Col>
            </Row>
          </Form.Item>
        </Form>
      </Container>
    </Modal>
  );
};

export default PersonUpdate;
